import type {AxiosError} from 'axios';
import {useMutation, useQueryClient, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {updatePassportPhotos, type UpdatePassportPhotosResponse} from '../../http';

export function useUpdatePassportPhotos(
	options?: UseMutationOptions<UpdatePassportPhotosResponse, AxiosError, FormData>,
): UseMutationResult<UpdatePassportPhotosResponse, AxiosError, FormData> {
	const queryClient = useQueryClient();

	return useMutation<UpdatePassportPhotosResponse, AxiosError, FormData>(
		(formData) => updatePassportPhotos(formData).then(({data}) => data),
		{
			...options,
			onSuccess: (data, variables, context) => {
				queryClient.invalidateQueries({queryKey: ['identification', 'info']});
				options?.onSuccess?.(data, variables, context);
			},
		},
	);
}
